<div class="sidenav-header">
    <mat-icon *ngIf="collapsed; else tableHeader">table_view</mat-icon>
    <ng-template #tableHeader>
        <h1 class="mat-h2 connection-title">{{connectionTitle}}</h1>
    </ng-template>
</div>

<app-content-loader *ngIf="tables === null; else tablesList"></app-content-loader>

<ng-template #tablesList>
    <div *ngIf="tables && tables.length; else noTables" class="tables-list">
        <mat-form-field *ngIf="!collapsed" appearance="fill" class="search-input">
            <input matInput name="search" #search="ngModel"
                placeholder="Search"
                [(ngModel)]="searchString"
                (keyup)="serach()">
            <mat-error *ngIf="foundTables.length === 0">Nothing found.</mat-error>
        </mat-form-field>
        <mat-nav-list data-testid="tables-list">
            <a mat-list-item *ngFor="let tableItem of foundTables" attr.data-testid="table-{{tableItem.table}}-list-item"
                routerLink="/dashboard/{{connectionID}}/{{tableItem.table}}"
                [queryParams]="{page_index: 0, page_size: 30}"
                [ngClass]="{'list-item_active': selectedTable === tableItem.table}"
                [matTooltip]="getTableName(tableItem)"
                [matTooltipDisabled]="getTableNameLength(getTableName(tableItem)) < 30 || collapsed"
                matTooltipPosition="right"
                routerLinkActive="list-item_active"
                class="table-list-item"
                (click)="closeRowPreview()">
                <div *ngIf="collapsed; else fullTableName"
                    class="table-list-initials"
                    [matTooltip]="getTableName(tableItem)">
                    <mat-icon *ngIf="tableItem.icon; else tableNameInitials" class="table-list-icon">
                        {{tableItem.icon}}
                    </mat-icon>
                    <ng-template #tableNameInitials>
                        {{tableItem.initials}}
                    </ng-template>
                </div>
                <ng-template #fullTableName>
                    {{getTableName(tableItem)}}
                </ng-template>
            </a>
        </mat-nav-list>
    </div>


    <ng-template #noTables>
        <p class="mat-body-1 empty-message">
            No tables in this connection.
        </p>

        <p class="mat-body-1 empty-message">
            Rocketadmin do not provide adding and deleting database tables, only editing ones. You can add a table with SQL editor.
        </p>
    </ng-template>
</ng-template>
